import { CloseOutlined } from '@mui/icons-material';
import { Divider, IconButton, Stack, Tooltip } from '@mui/material';
import { WrapWith } from '@procureai/ui-mui';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { OpenCloseProps } from '~/hooks';

interface DrawerHeaderProps {
  title: ReactNode;
  actions: ReactNode;
  onClose?: OpenCloseProps['onClose'];
}

export const DrawerHeader = ({ title, actions, onClose }: DrawerHeaderProps) => {
  const { t } = useTranslation(I18nNamespace.common, { keyPrefix: 'DrawerHeader' });
  return (
    <>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        flexGrow={0}
        sx={{ paddingX: 4, paddingY: 3 }}
      >
        {title}
        <Stack flexDirection="row" alignItems="center">
          {actions}
          {/* Close button only shown if onClose is provided - convenience option only */}
          {onClose ? (
            <WrapWith component={Tooltip} condition={true} title={t('close')}>
              <IconButton onClick={onClose}>
                <CloseOutlined />
              </IconButton>
            </WrapWith>
          ) : null}
        </Stack>
      </Stack>
      <Divider />
    </>
  );
};
